// src/store/telegramSlice.js

function decodeHistoryGroupKey(encodedValue) {
  const value = String(encodedValue || '');

  if (value.startsWith('neg')) {
    return `-${value.slice(3)}`;
  }

  if (value.startsWith('pos')) {
    return value.slice(3);
  }

  return '';
}

function parseStartParam(startParam) {
  const groupedHistoryMatch = String(startParam).match(/^historygroup_([^_]+)_([^_]+)--(.+)$/);

  if (groupedHistoryMatch) {
    const historyTargetUserId = String(groupedHistoryMatch[1] || '');
    const historyGroupKey = decodeHistoryGroupKey(groupedHistoryMatch[2]);
    const socketName = groupedHistoryMatch[3];

    return {
      gameId: 'history',
      isHistoryMode: true,
      historyScope: 'group',
      historyTargetUserId,
      historyGroupKey,
      testCanvas: false,
      gameParam: '',
      socketName,
      moderMode: false,
    };
  }

  const parts = String(startParam).split('-');
  const gameId = parts[0];

  return {
    gameId,
    isHistoryMode: gameId === 'history',
    historyScope: 'all',
    historyTargetUserId: '',
    historyGroupKey: '',
    testCanvas: ['test', 'brush'].includes(gameId),
    gameParam: parts[1],
    socketName: parts[2],
    moderMode: parts[4] === 'moder',
  };
}

const createTelegramSlice = (set, get, ref) => {
  const urlParams = new URLSearchParams(window.location.search);

  const adminUserId = '141015727'; // Las
  // const adminUserId = '1431457632'; // Ankot
  // const adminUserId = 375392538; // Anton
  // const adminUserId = 752215852; // AV
  // const adminUserId = 123; // test

  const startParam = urlParams.get('tgWebAppStartParam') || 'history--0';
  const parsedStartParam = parseStartParam(startParam);

  const inBrowser = urlParams.get('inBrowser');
  const cacheOff = urlParams.get('cacheOff');
  const historyBackParam = urlParams.get('historyBack') || '';

  const useCDN = window.location.hostname.includes('doodlegator.space') || window.location.hostname.includes('dgator.space');

  const isLocalhost = window.location.hostname === 'localhost';
  const socketHostUrl = isLocalhost ? 'http://localhost' : (() => {
    const currentUrl = new URL(window.location.href);
    const hostname = currentUrl.hostname;
    const parts = hostname.split('.');
    const mainDomain = parts.length > 2 ? parts.slice(-2).join('.') : hostname;
    return `wss://socket.${mainDomain}`;
  })();

  const telegramUserId = `${window.Telegram?.WebApp?.initDataUnsafe?.user?.id || adminUserId}`;
  const languageCode = `${window.Telegram?.WebApp?.initDataUnsafe?.user?.language_code || 'ru'}`;
  const initData = window.Telegram?.WebApp?.initData || '';

  const clientStartTime = Date.now();
  const clientId = `${telegramUserId}_${clientStartTime}`;

  ref.telegram = {
    urlParams,
    startParam,
    inBrowser,
    cacheOff,
    ...parsedStartParam,
    historyBackParam,
    useCDN,
    isLocalhost,
    socketHostUrl,
    telegramUserId,
    languageCode,
    initData,
    clientStartTime,
    clientId,
    historyIsOwnGroupView:
      parsedStartParam.historyScope === 'group'
      && String(parsedStartParam.historyTargetUserId || '') === String(telegramUserId),
  };

  ref.telegram.activeUserId = telegramUserId;

  return {
    isValid: null,
    isChecked: null,
    isHacker: false,
    telegramInitialized: false,
    isHistoryMode: parsedStartParam.isHistoryMode,
    historyBackParam,

    initTelegram: () => {
      window.logPerformance?.('Initializing WebApp...');
      const script = document.createElement('script');
      script.src = 'https://telegram.org/js/telegram-web-app.js';
      script.async = true;
      script.onload = () => {
        if (ref.telegram.initialized) { return; }
        ref.telegram.initialized = true;

        window.logPerformance?.('WebApp initialized');
        if (window.Telegram && window.Telegram.WebApp) {
          window.Telegram.WebApp.ready();
          window.Telegram.WebApp.expand();
          window.Telegram.WebApp.SettingsButton.show();

          window.Telegram.WebApp.onEvent('settingsButtonClicked', () => {
            ref.menu.methods.openMenu('drawing');
          });

          set({ telegramInitialized: true });

          try {
            window.Telegram.WebApp.disableVerticalSwipes();
          } catch (e) {
            document.body.classList.add('is-scroll-hack-enabled');
            setInterval(() => {
              window.scrollTo(2500, 2500);
            }, 200);
          }
        }
      };
      document.body.appendChild(script);
    },

    setIsValid: (value) => {
      set({
        isValid: value,
        isChecked: true,
        isHacker: value ? false : true,
      });
    },

    navigateToStartParam: (nextStartParam, options = {}) => {
      if (!nextStartParam) { return; }

      const nextUrl = new URL(window.location.href);
      nextUrl.searchParams.set('tgWebAppStartParam', nextStartParam);

      if (options.historyBackParam) {
        nextUrl.searchParams.set('historyBack', options.historyBackParam);
      } else {
        nextUrl.searchParams.delete('historyBack');
      }

      window.location.assign(nextUrl.toString());
    },
  };
};

export default createTelegramSlice;
